// extracted by mini-css-extract-plugin
export default {"main":"introduceTitle_main__fR2Bg","container":"introduceTitle_container__vCYxk","titles":"introduceTitle_titles__0B2G0","mask":"introduceTitle_mask__TETEj"};